enum EventGroup {
    MAIN = 'my',
    MARKET = 'market',
    CHAIN = 'chain',
    HOLIDAY = 'holiday',
}

export default EventGroup;
